import { render, staticRenderFns } from "./AdsListSales.vue?vue&type=template&id=353f793c&scoped=true&"
import script from "./AdsListSales.vue?vue&type=script&lang=js&"
export * from "./AdsListSales.vue?vue&type=script&lang=js&"
import style0 from "./AdsListSales.vue?vue&type=style&index=0&id=353f793c&prod&lang=scss&scoped=true&"
import style1 from "./AdsListSales.vue?vue&type=style&index=1&id=353f793c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353f793c",
  null
  
)

export default component.exports